import { orderSliceActions } from 'app/pages/order/redux/order-slice';
import type { AppDispatch, AppState } from 'app/redux/types/types';
import { RequestType } from 'app/pages/order/redux/model/order-request';

export const resetOrderStateActionCreator =
    (requests: RequestType[]) => (dispatch: AppDispatch, getState: () => AppState) => {
        const {
            order: { orderRequests },
        } = getState();

        const intersectionRequests = orderRequests.filter((request) => requests.includes(request.requestType));

        dispatch(orderSliceActions.resetOrderState(intersectionRequests));
    };
